module.exports = __webpack_public_path__ + "images/emoji/small_blue_diamond.75ba81d46f10921226e0.png";